const Footer = () => {
  return (
    <footer className="mt-10 bottom-2   text-center w-screen">
      All Rights Reversed © Tommy Elsayad 2024
    </footer>
  );
};
export default Footer;
